import Moment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment);

const getMinutesIntersectionOfDateRanges = (
  startDateTime1,
  endDateTime1,
  startDateTime2,
  endDateTime2,
) => {
  const range1 = moment.range(startDateTime1, endDateTime1);
  const range2 = moment.range(startDateTime2, endDateTime2);

  const result = range1.intersect(range2);

  return result ? Math.round(result.diff("minutes", true)) : 0;
};

export default getMinutesIntersectionOfDateRanges;



// WEBPACK FOOTER //
// ./src/helpers/get-minutes-intersection-of-date-ranges.js